// extracted by mini-css-extract-plugin
export var active = "_um-1";
export var circle = "_um-0";
export var completed = "_um-2";
export var connector = "_um-4";
export var connectorCompleted = "_um-7";
export var connectorSpacer = "_um-5";
export var iconStrokeOverride = "_um-8";
export var labelContainer = "_um-6";
export var pending = "_um-3";